import { Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import { useOrganization } from '_/contexts/OrganizationContext';
import DocumentTitle from '_/hooks/DocumentTitle';
import { useSchemas } from '_/hooks/useSchemas';
import React, { ReactElement } from 'react';

function SchemasContainer(): ReactElement {
  const { selectedOrgSlug } = useOrganization();
  const { data: schemas = [], isLoading } = useSchemas(selectedOrgSlug);

  DocumentTitle('Schemas');

  return (
    <AsyncPageContainer isLoading={!schemas || isLoading}>
      <Outlet />
    </AsyncPageContainer>
  );
}

export default SchemasContainer;
